// removed by extract-text-webpack-plugin
module.exports = {"starts-container":"StarRating__starts-container","startsContainer":"StarRating__starts-container","readOnly":"StarRating__readOnly","rate-input":"StarRating__rate-input","rateInput":"StarRating__rate-input","star-label":"StarRating__star-label","starLabel":"StarRating__star-label","star-mask":"StarRating__star-mask","starMask":"StarRating__star-mask","fix-icon-style":"StarRating__fix-icon-style","fixIconStyle":"StarRating__fix-icon-style","screenreadertext":"StarRating__screenreadertext"};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idp/ui-components/components/atoms/StarRating/StarRating.css
// module id = 1216
// module chunks = 8